<script setup lang="ts">
import url from '~/assets/images/logos/Teachme_Check_symbolmark.svg?url'

defineProps<{
  height: string
  width: string
}>()
</script>

<template>
  <img :src="url" class="image" />
</template>

<style scoped lang="scss">
.image {
  width: v-bind(width);
  height: v-bind(height);
}
</style>
